import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';

import { useInView } from 'react-intersection-observer';
import { useCountUp } from 'use-count-up';
import HomeProvidersCards from './Cards';
import { Animation } from '@starsoft/common/components';
import { sectionsRefer } from '@/enums/sectionsRefer';

export default function HomeProvider() {
  const { t } = useTranslation('common');
  const { ref, inView } = useInView({
    triggerOnce: true,
  });

  const { value } = useCountUp({
    isCounting: inView,
    start: 0,
    end: 250,
    easing: 'easeInCubic',
  });

  return (
    <div
      className={styles.container}
      data-theme="dark"
      ref={ref}
      id={sectionsRefer.providers}
    >
      <div className={styles.container__content}>
        <div className={styles.container__content__heading}>
          <Animation type="fadeInLeft">
            <div className={styles.container__content__heading__title}>
              {t('game_providers.title', {
                count: value,
              })}
            </div>
          </Animation>
          <Animation type="fadeInRight">
            <div className={styles.container__content__heading__description}>
              {t('game_providers.description')}
            </div>
          </Animation>
        </div>
        <div className={styles.container__content__cards}>
          <HomeProvidersCards />
        </div>
      </div>
    </div>
  );
}
